import { ConfirmHost } from './ConfirmDialog'
import { UiProviderBase, type UiProviderProps } from './context'
import { ToastViewport } from './Toast'

/**
 * Rahmen des UI-Kits – einmal um die Anwendung setzen. Liefert Tooltip-Verzögerung, den Link-Baustein der
 * Anwendung, die Toast-Fläche und den Dialog für `confirm()`.
 */
export function UiProvider({ link, children }: UiProviderProps) {
  return (
    <UiProviderBase link={link}>
      {children}
      <ToastViewport />
      <ConfirmHost />
    </UiProviderBase>
  )
}
